export default `
	gallery {
		... on GalleryPortrait {
			__typename
			reverse
			images {
				url(transform:galleryPortrait)
				filename
				id
				width
				height
				kind
			}
		}
		... on GalleryLandscape {
			__typename
			reverse
			images {
				url(transform:galleryLandscape)
				filename
				id
				width
				height
				kind
			}
		}
		... on GallerySingle {
			__typename
			images {
				url(transform:galleryBanner)
				filename
				id
				width
				height
				kind
			}
		}
		... on GalleryTextLarge {
			__typename
			text
		}
		... on GalleryImageTextSplit {
			__typename
			text
			images {
				url(transform:coverImage)
				filename
				id
				width
				height
				kind
			}
		}
	}
`;
